import { createTypes } from 'reduxsauce';

export default createTypes(
    `
    SET_TOAST
    RESET_TOAST
`,
    {
        prefix: 'toast/'
    }
);
